import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { TileButtonTwo } from '@sketch-note/design-system/src/components/tile-button';
import { Button, Checkbox, LoaderSm, Switch } from '@sketchnote/shared-components';
import classNames from 'classnames';
import * as React from 'react';
import Analytics from 'src/api/services/analytics/analytics';

import { useSettings } from './store';
import { usePreferencesStore } from './store/usePreferencesStore';
const { useCallback, useState, useEffect } = React;

export const Preferences = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const {
    checkboxFileInvite,
    checkboxWorkspaceInvite,
    checkboxFileMention,
    checkboxOrganisationInvite,
    toggleCheckboxOrganisationInvite,
    checkboxLessonMention,
    toggleCheckboxLessonMention,
    CheckboxActivityMention,
    toggleCheckboxActivityMention,
    CheckboxActivityShare,
    toggleCheckboxActivityShare,
    CheckboxActivityAssign,
    toggleCheckboxActivityAssign,
    CheckboxActivityInvite,
    toggleCheckboxActivityInvite,
    CheckboxActivityDeadline,
    toggleCheckboxActivityDeadline,
    CheckboxUpdateFeature,
    toggleCheckboxUpdateFeature,
    CheckboxUpdateTip,
    toggleCheckboxUpdateTip,
    CheckboxUpdateRecommended,
    toggleCheckboxUpdateRecommended,
    audioMode,
    setAudioMode,
    workLearnMode,
    setWorkLearnMode,
    sketchnoteRecommendations,
    // blogWork,
    // toggleBlogWork,
    // blog,
    // toggleBlog,
    // proTips,
    // toggleProTips,
    // proTipsWork,
    // toggleProTipsWork,
    recentAssignedTasks,
    toggleRecentAssignedTasks,
    // continueFiles,
    // toggleContinueFiles,
    favoriteFiles,
    toggleFavoriteFiles,
    loFi,
    toggleLoFi,
    loFiWork,
    toggleLoFiWork,
    keepLearning,
    toggleKeepLearning,
    toggleSketchnoteRecommendations,
    toggleCheckboxFileInvite,
    toggleCheckboxWorkspaceInvite,
    toggleCheckboxFileMention,
    askAlex,
    toggleAskAlex,
    learnAskAlex,
    toggleLearnAskAlex,
  } = usePreferencesStore((state) => state);

  const [callbacks] = useSettings();
  const [snackbarModalIsOpen, setSnackbarModalIsOpen] = useState(false);
  const [loaderIsOpen, setLoaderIsOpen] = useState(false);
  const [audioPreference, setAudioPreference] = useState<string>('');

  useEffect(() => {
    setAudioPreference(audioMode);
    setWorkLearnMode(workLearnMode);
  }, []);

  const dashboardSettings = [
    // {
    //   label: '📄 Continue building your files',
    //   isChecked: continueFiles,
    //   value: 'continue_files',
    // },
    {
      label: '⭐️ Your favorite files',
      isChecked: favoriteFiles,
      value: 'favorite_files',
    },
    // { label: '☠️ Upcoming deadlines', isChecked: upcomingDeadlines, value: 'upcoming_deadlines' },
    { label: '🧔 AskAlex', isChecked: askAlex, value: 'ask_alex' },
    {
      label: '🎓 Tasks recently assigned to you',
      isChecked: recentAssignedTasks,
      value: 'recent_assigned_tasks',
    },
    // { label: '🎊 Sketchnote blog', isChecked: blogWork, value: 'sketchnote_blog_work' },
    { label: '🎵 Lo-fi chill zone', isChecked: loFiWork, value: 'loFi_work' },
    // { label: '💡 Pro tips', isChecked: proTipsWork, value: 'pro_tips_work' },
  ];

  const learnDashboardSettings = [
    { label: '✏️ Keep learning', isChecked: keepLearning, value: 'keep_learning' },
    // {
    //   label: '🎤 Sketchnote recommendations',
    //   isChecked: sketchnoteRecommendations,
    //   value: 'sketchnote_recommendations',
    // },
    // { label: '🎊 Sketchnote blog', isChecked: blog, value: 'sketchnote_blog_learn' },
    { label: '🎵 Lo-fi chill zone', isChecked: loFi, value: 'loFi_learn' },
    { label: '🧔 Ask alex', isChecked: learnAskAlex, value: 'ask_alex_learn' },
    // { label: '💡 Pro tips', isChecked: proTips, value: 'pro_tips_learn' },
  ];

  const emailNotifications = [
    {
      label: "Files I've been invited to",
      isChecked: checkboxFileInvite,
      value: 'fileInvite',
    },
    {
      label: "Workspace I've been invited to",
      isChecked: checkboxWorkspaceInvite,
      value: 'workspaceInvite',
    },

    {
      label: "Organizations I've been invited to be a part of ",
      isChecked: checkboxOrganisationInvite,
      value: 'organisationInvite',
    },

    {
      label: "Files I've been mentioned in",
      isChecked: checkboxFileMention,
      value: 'documentMention',
    },
  ];

  const activityAlerts = [
    {
      label: 'When someone mentions me',
      isChecked: CheckboxActivityMention,
    },
    {
      label: 'When a file is shared with me',
      isChecked: CheckboxActivityShare,
    },
    {
      label: 'When someone assigns me a task',
      isChecked: CheckboxActivityAssign,
    },
  ];
  const otherEmailUpdates = [
    {
      label: 'New features and upgrades',
      isChecked: CheckboxUpdateFeature,
    },
    {
      label: 'Tips and tricks for my career path',
      isChecked: CheckboxUpdateTip,
    },
    {
      label: 'Recommended modules',
      isChecked: CheckboxUpdateRecommended,
    },
  ];

  const handleAudioModeSelect = (value) => {
    const preferenceName = value === 'play_audio' ? 'Listen Flashcards' : 'Read Flashcards';
    Analytics.track('Audio Preference Change', {
      'Updated Preference': preferenceName,
    });
    Analytics.people.set({
      Preference: preferenceName,
    });
    setAudioPreference(value);
    setAudioMode(value);
  };

  const handleWorkLearnModeSelect = (value) => {
    setWorkLearnMode(value);
  };

  const handleSnackbarModal = () => {
    setSnackbarModalIsOpen(false);
  };

  const handleLoaderModal = () => {
    setLoaderIsOpen(false);
  };

  const trackCheckboxEvent = (alertName, alertType, response) => {
    Analytics.track('Alert Preference Change', {
      'Updated Alert Type': alertType,
      'Updated Alert': alertName,
      Response: response ? 'On' : 'Off',
    });
    Analytics.people.set({
      [alertName]: response ? 'On' : 'Off',
    });
  };

  const handletoggleCheckboxEmail = useCallback((value, label, e) => {
    trackCheckboxEvent(label, 'Send me email notifications for', e);
    switch (value) {
      case 'fileInvite':
        toggleCheckboxFileInvite(e);
        break;
      case 'organisationInvite':
        toggleCheckboxOrganisationInvite(e);
        break;
      case 'workspaceInvite':
        toggleCheckboxWorkspaceInvite(e);
        break;
      case 'lessonMention':
        toggleCheckboxLessonMention(e);
        break;
      case 'fileMention':
        toggleCheckboxFileMention(e);
        break;
    }
  }, []);

  const handletoggleCheckboxActivity = useCallback((label, e) => {
    trackCheckboxEvent(label, 'Send me activity alerts', e);
    switch (label) {
      case 'When someone mentions me':
        toggleCheckboxActivityMention(e);
        break;
      case 'When a creation or doc is shared with me':
        toggleCheckboxActivityShare(e);
        break;
      case 'When someone invites me to collaborate':
        toggleCheckboxActivityInvite(e);
        break;
      case 'When someone assigns me a task':
        toggleCheckboxActivityAssign(e);
        break;
      case 'For upcoming deadline reminders':
        toggleCheckboxActivityDeadline(e);
        break;
    }
  }, []);

  const handletoggleDashboardSettings = useCallback((value) => {
    switch (value) {
      case 'sketchnote_recommendations':
        toggleSketchnoteRecommendations(sketchnoteRecommendations);
        break;

      // case 'pro_tips_learn':
      //   toggleProTips(proTips);
      //   break;
      // case 'pro_tips_work':
      //   toggleProTipsWork(proTips);
      //   break;

      case 'recent_assigned_tasks':
        toggleRecentAssignedTasks(recentAssignedTasks);
        break;

      // case 'sketchnote_blog_work':
      //   toggleBlogWork(blogWork);
      //   break;

      // case 'sketchnote_blog_learn':
      //   toggleBlog(blog);
      //   break;

      case 'keep_learning':
        toggleKeepLearning(keepLearning);
        break;
      // case 'continue_files':
      //   toggleContinueFiles(continueFiles);
      //   break;
      case 'favorite_files':
        toggleFavoriteFiles(favoriteFiles);
        break;

      case 'loFi_learn':
        toggleLoFi(loFi);
        break;
      case 'loFi_work':
        toggleLoFiWork(loFiWork);
        break;

      case 'ask_alex':
        toggleAskAlex(askAlex);
        break;

      case 'ask_alex_learn':
        toggleLearnAskAlex(learnAskAlex);
        break;
    }
  }, []);

  const handletoggleCheckboxUpdate = useCallback((label, e) => {
    if (label === 'New features and upgrades') toggleCheckboxUpdateFeature(e);
    else if (label === 'Tips and tricks for my career path') toggleCheckboxUpdateTip(e);
    else if (label === 'Recommended modules') toggleCheckboxUpdateRecommended(e);
  }, []);

  const handleSaveChanges = async () => {
    setLoaderIsOpen(true);

    const response = await callbacks?.onUpdatePreferences?.({
      notifications: {
        email: {
          workspace_invite: checkboxWorkspaceInvite,
          file_invite: checkboxFileInvite,
          organisation_invite: checkboxOrganisationInvite,
          mention_file: checkboxFileMention,

          mention_lesson: checkboxLessonMention,
        },
        alerts: {
          mentions: CheckboxActivityMention,

          microtask_assign: CheckboxActivityAssign,
          deadline_reminders: CheckboxActivityDeadline,
        },
        // other_email: {
        //   new_features: CheckboxUpdateFeature,
        //   tips_n_tricks: CheckboxUpdateTip,
        //   recommended_modules: CheckboxUpdateRecommended
        // }
      },
      audio_mode: audioMode,
      op_mode: workLearnMode,
      dashboard: {
        // work_continue_files: continueFiles,
        recommendations: sketchnoteRecommendations,
        // blog: blog,
        // work_blog: blogWork,
        // pro_tips: proTips,
        // work_protips: proTipsWork,
        work_lofi: loFiWork,
        lofi: loFi,
        recent_assigned_tasks: recentAssignedTasks,
        keep_learning: keepLearning,
        work_favorite_files: favoriteFiles,
        ask_alex: askAlex,
        ask_alex_learn: learnAskAlex,
      },
    });

    if (response.isSuccess) {
      setLoaderIsOpen(false);
      setSnackbarModalIsOpen(true);
      setTimeout(function () {
        setSnackbarModalIsOpen(false);
      }, 1500);
    }
  };

  return (
    <div>
      <div className="overflow-y-auto px-48 " style={{ height: '53rem' }}>
        {/* <section className="pb-34">
          <div className="flex justify-between">
            <span>⚙️ Enable Work mode-Learn mode toggle on dashboard</span>
            <span className="mt-4">
              <Switch checked={true} />
            </span>
          </div>
        </section> */}
        {/* <section className="pb-48">
          <span className="block font-medium text-base text-gray-999 mb-6">
            Choose default section
          </span>
          <p className="text-sm text-gray-600 mb-24">
            You can choose the section you want to work with, by default. If you wish to change from
            Work mode to Learn mode and vice versa, you can do this via settings
          </p>
          <div className="flex mt-16">
            <TileButtonTwo
              selected={workLearnMode === 'work'}
              className="w-284"
              onClick={handleWorkLearnModeSelect.bind(this, 'work')}
            >
              <span role="img" aria-label="options">
                🗄 &nbsp;&nbsp;Work mode
              </span>
            </TileButtonTwo>
            <TileButtonTwo
              selected={workLearnMode === 'learn'}
              className="w-284 ml-16 text-center"
              onClick={handleWorkLearnModeSelect.bind(this, 'learn')}
            >
              <span role="img" aria-label="options">
                📚 &nbsp;&nbsp;Learn mode
              </span>
            </TileButtonTwo>
          </div>
        </section> */}
        <section className="border-gray-200 pt-16">
          <span className="block font-medium text-base text-gray-999 mb-6">
            🗄 &nbsp;&nbsp;Work mode dashboard view settings
          </span>
          <p className="text-sm text-gray-600 mb-32">
            Customize your dashboard to suit your preferences. Toggle what you want to see on your
            dashboard
          </p>
          <div className="mb-10">
            {dashboardSettings.map(({ label, value, isChecked }, index) => (
              <p
                key={`${label}-${index}`}
                className={classNames({
                  'py-10  flex justify-between': true,
                  'border-b': value !== 'pro_tips',
                })}
              >
                <span className="text-sm text-gray-600">{label}</span>
                <span>
                  <Switch
                    className="mt-2"
                    checked={isChecked}
                    onChange={handletoggleDashboardSettings.bind(this, value)}
                  />
                </span>
              </p>
            ))}
          </div>
        </section>
        {/* <section className=" border-gray-200 pb-32 pt-16">
          <span className="block font-medium text-base text-gray-999 mb-6">
            📚 &nbsp;&nbsp;Learn mode dashboard view settings
          </span>
          <p className="text-sm text-gray-600 mb-32">
            Customize your dashboard to suit your preferences. Toggle what you want to see on your
            dashboard
          </p>
          <div className="mb-10">
            {learnDashboardSettings.map(({ label, value, isChecked }, index) => (
              <p
                key={`${label}-${index}`}
                className={classNames({
                  'py-10  flex justify-between': true,
                  'border-b': value !== 'ask_alex_learn',
                })}
              >
                <span className="text-sm text-gray-600">{label}</span>
                <span>
                  <Switch
                    className="mt-2"
                    checked={isChecked}
                    onChange={handletoggleDashboardSettings.bind(this, value)}
                  />
                </span>
              </p>
            ))}
          </div>
        </section> */}
        {/* <section className="py-48 border-b">
          <span className="block font-medium text-base text-gray-999 mb-6">Lesson audio mode</span>
          <p className="text-sm text-gray-600 mb-24">
            You can choose to read through the cards at your own pace, or listen to the lessons, as
            our mentors guide you through it. Choose how you want to start your lesson, by default
          </p>
          <div className="flex mt-16">
            <TileButtonTwo
              selected={audioPreference === 'play_audio'}
              className="w-284"
              onClick={handleAudioModeSelect.bind(this, 'play_audio')}
            >
              <span role="img" aria-label="options">
                🎧 &nbsp;&nbsp;Listen to flashcards
              </span>
            </TileButtonTwo>
            <TileButtonTwo
              selected={audioPreference === 'no_play'}
              className="w-284 ml-16 text-center"
              onClick={handleAudioModeSelect.bind(this, 'no_play')}
            >
              <span role="img" aria-label="options">
                👓 &nbsp;&nbsp;Read the flashcards
              </span>
            </TileButtonTwo>
          </div>
        </section> */}
        <section className="py-48">
          <span className="mb-24 block font-medium">Send me email notifications for</span>
          {emailNotifications.map(({ label, value, isChecked }, index) => (
            <Checkbox
              wrapperClass="mb-15"
              key={label}
              checked={isChecked}
              onChange={handletoggleCheckboxEmail.bind(this, value, label)}
            >
              {label}
            </Checkbox>
          ))}

          <span className="mt-40 mb-24 block font-medium">Send me activity alerts </span>
          {activityAlerts.map(({ label, isChecked }, index) => (
            <Checkbox
              wrapperClass="mb-15"
              key={label}
              checked={isChecked}
              onChange={handletoggleCheckboxActivity.bind(this, label)}
            >
              {label}
            </Checkbox>
          ))}
          {/* <span className="mt-40 mb-32 block font-medium">Other email updates</span>
          {otherEmailUpdates.map(({ label, isChecked }) => (
            <Checkbox
              wrapperClass="mb-15"
              key={label}
              checked={isChecked}
              onChange={handletoggleCheckboxUpdate.bind(this, label)}>
              {label}
            </Checkbox>
          ))} */}
        </section>
      </div>

      <div className="sticky flex justify-end px-64 py-12 border-t border-gray-200 ">
        <Button status="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button status="primary" className="ml-10" onClick={handleSaveChanges}>
          Save changes
        </Button>
      </div>

      <Modal isOpen={loaderIsOpen} onClose={handleLoaderModal}>
        <ModalOverlay />
        <ModalContent style={{ width: '38.4rem', padding: '30px', marginTop: '20rem' }}>
          <p className="font-semibold mb-20"> We&apos;re saving your changes </p>
          <LoaderSm className="mx-auto text-xss" />
        </ModalContent>
      </Modal>

      <Modal isOpen={snackbarModalIsOpen} onClose={handleSnackbarModal}>
        <ModalContent style={{ width: '180px', borderRadius: '10px', marginTop: '65rem' }}>
          <StandardSnack text="Changes Saved" />
        </ModalContent>
      </Modal>
    </div>
  );
};
